import {ReactNode} from "react";
import {AdminPageTitle} from "../../../atoms/admin-layout/AdminPageTitle";
import {DocumentTitle} from "../../../atoms/document-title";
import {HeaderActions, HubAndSpokePageHeader} from "../styles";

type Props = Readonly<{
  title: string;
  /** Rendered on the right side of the title row (buttons, filters). */
  actions?: ReactNode;
  children: ReactNode;
}>;

/** Shared shell for every Hub & Spoke page: title row + content. */
export const HubAndSpokePage = ({title, actions, children}: Props) => (
  <>
    <DocumentTitle title={`Reside - Admin - ${title}`} />
    <HubAndSpokePageHeader>
      <AdminPageTitle>{title}</AdminPageTitle>
      {actions && <HeaderActions>{actions}</HeaderActions>}
    </HubAndSpokePageHeader>
    {children}
  </>
);
